import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Variables d'environnement Supabase manquantes. " +
      'Vérifie ton fichier .env.development'
  );
}

// ─────────────────────────────────────────────────────────────
// Client Supabase
//
// Notes de configuration :
//   - storageKey 'alambic-auth' : clé courte facile à clear si besoin
//     (au lieu de 'sb-ypvsiiujhmxdrfyyxrqu-auth-token').
//   - persistSession : on garde la session entre les sessions navigateur
//     (sinon il faudrait se reconnecter à chaque ouverture du navigateur).
//   - autoRefreshToken : Supabase rafraîchit automatiquement l'access_token
//     en arrière-plan avant qu'il expire (sans bloquer l'UI grâce à
//     l'AuthContext qui débloque l'app dès qu'il a la session locale).
// ─────────────────────────────────────────────────────────────
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storageKey: 'alambic-auth',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});

// ─────────────────────────────────────────────────────────────
// Garde-fou : si on charge la page avec une vieille clé Supabase
// (avant qu'on personnalise storageKey), on la nettoie pour éviter
// les conflits.
// ─────────────────────────────────────────────────────────────
if (typeof window !== 'undefined') {
  try {
    const oldKeys = Object.keys(localStorage).filter(
      (k) => k.startsWith('sb-') && k.endsWith('-auth-token')
    );
    for (const k of oldKeys) {
      localStorage.removeItem(k);
    }
  } catch {
    // localStorage indisponible (mode privé strict) — on ignore
  }
}
